import gql from 'graphql-tag';

export const ENSEIGNE_INFO_FRAGMENT = gql`
  fragment EnseigneInfo on Enseigne {
    id
    type
    name
    address
    country
    zipCode
    city
    phone
    email
    SIRET
    IBAN
    BIC
    SIREN
    physicalModel
    socialReason
    linkedWithSomething
  }
`;
